import { Icon24Share } from '@vkontakte/icons';
import {
  Div, Group, Panel, Title
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo } from 'react';
import {
  OKIcon, OKShareButton, VKIcon, VKShareButton
} from 'react-share';
import { AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { $isStandAlone } from 'src/entity/User';
import {
  shareToVkInVkFx,
  shareToVkStandaloneFx
} from 'src/entity/Voiting';
import {
  VK_SHARE_TITLE,
  VK_SHARE_URL,
  WEB_SHARE_TITLE,
  WEB_SHARE_URL
} from 'src/shared/config';
import { Cover } from 'src/shared/ui/cover';
import { CustomCellButton } from 'src/shared/ui/custom-cell-button';
import styles from './styles.module.scss';

export interface IResultsPanel {
  id: AppPanelsT;
}

export const ResultsPanel = memo(({ id }: IResultsPanel) => {
  // ЗАМЕНИТЬ НА ПОЛУЧЕНИЕ ДАННЫХ С СЕРВЕРА КОДА БУДЕТ ГОТОВА АПИХА
  // const secondStageVotes = useUnit($chooseSecondStageVotes);

  const [
    shareToVkInVk,
    shareToVkStandalone,
    isStandAlone
  ] = useUnit([
    shareToVkInVkFx,
    shareToVkStandaloneFx,
    $isStandAlone
  ]);

  return (
    <Panel id={id}>
      <Group className={styles.results}>
        <Div className={styles.info}>
          {/* {Object.values(secondStageVotes).map(
            ({
              nominationLabel,
              nomineeLabel,
              currentNomination,
              nomineeId
            }) => (
              <ResultCard
                key={currentNomination}
                nominationLabel={nominationLabel}
                nomineeLabel={nomineeLabel}
                nomineeId={nomineeId}
                currentNomination={currentNomination}
              />
            )
          )} */}

          <Div className={styles.share}>
            <Title weight='3' level='2' className={styles.text}>
              Обязательно поделись этой страницей с друзьями! Узнайте чьи герои
              победили!
            </Title>
            {isStandAlone ? (
              <Div>
                <Div className={styles.share__buttons}>
                  <VKShareButton
                    onClick={shareToVkStandalone}
                    url={VK_SHARE_URL}
                    title={VK_SHARE_TITLE}
                    className='results__share-button'
                  >
                    <VKIcon size={48} round />
                  </VKShareButton>

                  <OKShareButton
                    // onClick={shareToOkStandalone}
                    url={WEB_SHARE_URL}
                    title={WEB_SHARE_TITLE}
                    className='results__share-button'
                  >
                    <OKIcon size={48} round />
                  </OKShareButton>
                </Div>
              </Div>
            ) : (
              <CustomCellButton onClick={shareToVkInVk} after={<Icon24Share />}>
                Поделиться
              </CustomCellButton>
            )}
          </Div>
        </Div>
      </Group>
      <Cover />
    </Panel>
  );
});
